module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/282.a779d85e.png";